import styled from 'styled-components';

const Wrapper = styled.div`
  .items-center {
    display: grid;
    grid-template-columns: 1fr 0.5fr 1fr 0.5fr 1fr;
    align-items: center;
    justify-items: center;
    gap: 20px;
    padding: 30px 15px;

    @media (max-width: 768px) {
      grid-template-columns: 1fr;
      gap: 30px;
    }
  }

  .step {
    text-align: center;
        height: -webkit-fill-available;
    img {
      width: 120px;
      max-width: 100%;
      height: auto;
      margin-top: 15px;
    }

    h4 {
      font-weight: bold;
      margin-bottom: 10px;
      font-size: 18px;
    }

    p {
      color: #424242;
      font-size: 16px;
      font-weight: 600;
      margin: 0 auto;
      max-width: 250px;
    }
  }

  .arrow {
    display: flex;
    justify-content: center;
    align-items: center;

    img {
      width: 80px; 
      height: auto;

      @media (max-width: 768px) {
        transform: rotate(90deg);
        width: 30px; // smaller size for small screens
        margin: 0 auto;
      }
    }

    @media (max-width: 768px) {
      margin: -10px 0;
    }
  }

  .upload-media,
  .ai-processing,
  .getMom {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 20px;
    border-radius: 20px;
    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
    width: 100%;
  }

  .upload-media {
    background: #fee;
  }

  .ai-processing {
    background: #f1fff2;
  }

  .getMom {
    background: #fff7e5;
  }
`;


export default Wrapper;
